import { WorkflowVersion } from "@/components/Workflows/types";
import { ListPromptVersion } from "@/types";
import { Label } from "../VersionTab/types";

const useOptimisticVersions = (
  versions: (WorkflowVersion | ListPromptVersion)[] | undefined,
  pendingLabelMoves: {
    [key: string]: {
      sourceVersionId: number;
      targetVersionId: number;
      label: Label;
    };
  },
) => {
  const getAugmentedVersions = () => {
    if (!versions || Object.keys(pendingLabelMoves).length === 0) {
      return versions;
    }

    const augmentedVersions = JSON.parse(JSON.stringify(versions));

    Object.values(pendingLabelMoves).forEach(
      ({ sourceVersionId, targetVersionId, label }) => {
        const sourceVersionIndex = augmentedVersions.findIndex(
          (v: any) => v.id === sourceVersionId,
        );
        const targetVersionIndex = augmentedVersions.findIndex(
          (v: any) => v.id === targetVersionId,
        );

        if (sourceVersionIndex >= 0 && targetVersionIndex >= 0) {
          const sourceVersion = augmentedVersions[sourceVersionIndex];
          sourceVersion.labels = sourceVersion.labels.filter(
            (l: Label) => l.id !== label.id,
          );

          const targetVersion = augmentedVersions[targetVersionIndex];
          if (!targetVersion.labels.some((l: Label) => l.id === label.id)) {
            targetVersion.labels.push(label);
          }
        }
      },
    );

    return augmentedVersions;
  };

  return { getAugmentedVersions };
};

export default useOptimisticVersions;
